    import React from 'react';
    import { Modal, Button } from 'react-bootstrap';
    import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
    import { faTimes } from '@fortawesome/free-solid-svg-icons';

    interface MessageModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  message: string;
  variant?: 'success' | 'danger' | 'info' | 'warning'; // סוג ההודעה
  onConfirm?: () => void; // פונקציה לאישור
  confirmText?: string; // טקסט כפתור האישור
  showCancel?: boolean; // האם להציג כפתור ביטול
}

    const MessageModal: React.FC<MessageModalProps> = ({ 
  show, 
  onHide, 
  title, 
  message, 
  variant = 'info',
  onConfirm,
  confirmText,
  showCancel = true
}) => {
      return (
        <Modal show={show} onHide={onHide} centered>
          <Modal.Header closeButton className={`bg-${variant} text-white`}>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{message}</p>
          </Modal.Body>
          <Modal.Footer>
            {onConfirm && (
              <Button variant={variant} onClick={onConfirm}>
                {confirmText || 'אישור'}
              </Button>
            )}
            {(showCancel || !onConfirm) && (
              <Button variant="secondary" onClick={onHide}>
                <FontAwesomeIcon icon={faTimes} className="me-1" />
                {onConfirm ? 'ביטול' : 'סגור'}
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      );
    };

    export default MessageModal;
    